import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";

import { signinRedirectCallback } from "../oidcClient/userService";
import LoadingScreen from "src/components/Common/Navigation/LoadingScreen";
import { appInsightsData } from "src/helper/AppInsightsData";
import { logger } from "src/routes/LoggedIn";
import { getHeaderTitleFromPath } from "src/helper/HelperFunctions";
import { User } from "oidc-client";
import { SessionStorageConstants } from "src/Core/Common/Constants";

function SigninOidc() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        async function signinAsync() {
            const user = await signinRedirectCallback();
            let pageTitle = appInsightsData.MailBox.Inbox.PageTitle;
            if (location?.search) {
                const params: any = queryString.parse(location.search);
                if (params.callback_args) {
                    navigate(params.callback_args);
                    pageTitle = getHeaderTitleFromPath(params.callback_args);
                } else {
                    navigate("/");
                }
            } else {
                if (sessionStorage.getItem(SessionStorageConstants.IS_SIGN_IN_DIALOG)) {
                    messageDialog(user);
                }
                navigate("/");
            }

            logger.trackEvent({
                name: appInsightsData.UserAuthentication.LoggedIn,
                properties: {
                    page: pageTitle,
                    outlookPlatform: Office.context.diagnostics?.platform,
                    outlookVersion: Office.context.diagnostics?.version,
                },
            });
        }
        signinAsync();
    }, [navigate]);

    function messageDialog(user: User) {
        const msg = JSON.stringify({ from: "taskpane", user: user.toStorageString() });
        Office.context.ui.messageParent(msg);
    }

    return <LoadingScreen />;
}

export default SigninOidc;
